(function() {
  'use strict';

  console.log('Cart drawer JS loaded');

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }

  function initCartDrawer() {
    console.log('Initializing cart drawer');

    // Helper to relocate native Consumer Priority Service (CPS) widgets into cart item warranty anchors
    function relocateCpsElements() {
      const cpsElements = document.querySelectorAll('.cps:not(.ee-cart__item-warranty *)');
      if (!cpsElements.length) return;

      cpsElements.forEach(function(cpsEl) {
        const idEl = cpsEl.querySelector('input[product-id], [product-id], input[data-product-id], [data-product-id], input[data-id], .warranty_form, input[name*="cps"], input[name*="CPS"]');
        const variantId = idEl ? (idEl.getAttribute('product-id') || idEl.getAttribute('data-product-id') || idEl.getAttribute('data-id')) : null;

        let targetContainer = null;
        if (variantId) {
          targetContainer = document.querySelector('cart-drawer .ee-cart__item-warranty[data-variant-id="' + variantId + '"]') ||
                            document.querySelector('cart-drawer .ee-cart__item-warranty[data-product-id="' + variantId + '"]') ||
                            document.querySelector('.ee-cart__item-warranty[data-variant-id="' + variantId + '"]') ||
                            document.querySelector('.ee-cart__item-warranty[data-product-id="' + variantId + '"]');
        }

        if (!targetContainer) {
          targetContainer = document.querySelector('cart-drawer .ee-cart__item-warranty') ||
                            document.querySelector('.ee-cart__item-warranty');
        }

        if (targetContainer && !targetContainer.contains(cpsEl)) {
          targetContainer.appendChild(cpsEl);
        }
      });
    }

    // Cart Drawer functionality
    function openCartDrawer() {
      console.log('Opening cart drawer');
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
        console.log('Cart drawer opened');
        relocateCpsElements();
        setTimeout(relocateCpsElements, 300);
        setTimeout(relocateCpsElements, 800);
      } else {
        console.error('Cart drawer element not found');
      }
    }

    function closeCartDrawer() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.removeAttribute('open');
        document.body.style.overflow = '';
      }
    }

    // Update cart drawer contents via Section Rendering API
    function updateCartDrawer() {
      fetch('/?section_id=cart-drawer', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(html => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          // Create a temporary container to parse the HTML
          const temp = document.createElement('div');
          temp.innerHTML = html;

          // Update cart items
          const newContents = temp.querySelector('.drawer__contents');
          const currentContents = drawer.querySelector('.drawer__contents');
          if (newContents && currentContents) {
            currentContents.innerHTML = newContents.innerHTML;
          }

          // Update cart count in header if exists
          const headerCartCount = document.querySelector('.cart-count-bubble');
          if (headerCartCount) {
            fetch('/cart.js')
              .then(r => r.json())
              .then(cart => {
                headerCartCount.textContent = cart.item_count;
                if (cart.item_count > 0) {
                  headerCartCount.classList.remove('hidden');
                }
              });
          }

          // Remove empty class if cart has items
          const newItems = temp.querySelector('.drawer__cart-items');
          if (newItems && newItems.children.length > 0) {
            drawer.classList.remove('is-empty');
          }

          // Re-attach event listeners for quantity buttons
          attachCartItemListeners();
          relocateCpsElements();
          setTimeout(relocateCpsElements, 300);
          setTimeout(relocateCpsElements, 800);
        }
      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
      });
    }

    // Attach event listeners to cart item buttons
    function attachCartItemListeners() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      // Quantity minus buttons
      drawer.querySelectorAll('.quantity__button--minus').forEach(btn => {
        btn.addEventListener('click', function() {
          if (this.disabled || this.classList.contains('is-loading')) return;

          const input = this.closest('.quantity').querySelector('.quantity__input');
          const key = input.dataset.key;
          const currentVal = parseInt(input.value) || 1;

          if (currentVal > 1) {
            setButtonLoading(this, true);
            input.value = currentVal - 1;
            if (key) updateCartItem(key, currentVal - 1, () => setButtonLoading(this, false));
          } else if (currentVal === 1 && key) {
            setButtonLoading(this, true);
            removeCartItem(key, () => setButtonLoading(this, false));
          }
        });
      });

      // Quantity plus buttons
      drawer.querySelectorAll('.quantity__button--plus').forEach(btn => {
        btn.addEventListener('click', function() {
          if (this.disabled || this.classList.contains('is-loading')) return;

          const input = this.closest('.quantity').querySelector('.quantity__input');
          const key = input.dataset.key;
          const currentVal = parseInt(input.value) || 0;

          setButtonLoading(this, true);
          input.value = currentVal + 1;
          if (key) updateCartItem(key, currentVal + 1, () => setButtonLoading(this, false));
        });
      });

      // Remove buttons
      drawer.querySelectorAll('.drawer__cart-item-remove').forEach(btn => {
        btn.addEventListener('click', function() {
          if (this.disabled || this.classList.contains('is-loading')) return;

          const input = this.closest('.drawer__cart-item-details').querySelector('.quantity__input');
          const key = input.dataset.key;
          if (key) {
            setButtonLoading(this, true);
            removeCartItem(key, () => setButtonLoading(this, false));
          }
        });
      });
    }

    // Set individual button loading state (visual only, disabled handled globally)
    function setButtonLoading(button, isLoading) {
      button.classList.toggle('is-loading', isLoading);
      const svg = button.querySelector('svg');
      if (svg) {
        svg.style.visibility = isLoading ? 'hidden' : 'visible';
      }
    }

    // Disable all cart buttons during update
    function setAllButtonsDisabled(disabled) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      drawer.querySelectorAll('.quantity__button, .drawer__cart-item-remove').forEach(btn => {
        btn.disabled = disabled;
        if (disabled) {
          btn.style.opacity = '0.5';
        } else {
          btn.style.opacity = '';
        }
      });

      // Also toggle subtotal updating state
      const subtotalPrice = drawer.querySelector('.drawer__subtotal-price');
      if (subtotalPrice) {
        subtotalPrice.classList.toggle('is-updating', disabled);
      }
    }

    // Update cart item quantity
    function updateCartItem(key, quantity, callback) {
      setAllButtonsDisabled(true);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(response => {
        if (!response.ok) throw new Error('Failed to update cart');
        return updateCartDrawer();
      })
      .then(() => {
        setAllButtonsDisabled(false);
        if (callback) callback();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        setAllButtonsDisabled(false);
        if (callback) callback();
      });
    }

    // Remove cart item
    function removeCartItem(key, callback) {
      setAllButtonsDisabled(true);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(response => {
        if (!response.ok) throw new Error('Failed to remove item');
        return updateCartDrawer();
      })
      .then(() => {
        setAllButtonsDisabled(false);
        if (callback) callback();
      })
      .catch(error => {
        console.error('Error removing item:', error);
        setAllButtonsDisabled(false);
        if (callback) callback();
      });
    }

    // Custom element for cart drawer
    if (!customElements.get('cart-drawer')) {
      class CartDrawer extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
          this.querySelector('.drawer__close')?.addEventListener('click', this.close.bind(this));
          this.addEventListener('click', (event) => {
            if (event.target === this || event.target.classList.contains('cart-drawer__overlay')) {
              this.close();
            }
          });
        }

        close() {
          this.removeAttribute('open');
          document.body.style.overflow = '';
        }

        open(triggerElement) {
          this.setAttribute('open', '');
          document.body.style.overflow = 'hidden';
          triggerElement?.focus();
          relocateCpsElements();
          setTimeout(relocateCpsElements, 300);
          setTimeout(relocateCpsElements, 800);
        }
      }

      customElements.define('cart-drawer', CartDrawer);
    }

    // Helper to detect selected Consumer Priority Service (CPS) Extended Warranty
    function getSelectedCpsWarranty(form) {
      // 1. Check form inputs first (e.g. hidden inputs injected by CPS app or radio options)
      if (form) {
        const cpsInputs = form.querySelectorAll('input[name*="cps"], input[name*="CPS"], input[name*="warranty"], input[data-cps-variant-id]');
        for (let i = 0; i < cpsInputs.length; i++) {
          const input = cpsInputs[i];
          if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) continue;
          const val = input.value || input.dataset.cpsVariantId;
          if (val && /^\d+$/.test(val.trim()) && val.trim() !== '0') {
            return {
              id: val.trim(),
              title: input.dataset.title || 'Extended Warranty',
              properties: {}
            };
          }
        }
      }

      // 2. Check active/selected CPS button or element in the DOM
      const selectors = [
        '.cps-button-group-wrapper .selected',
        '.cps-button-group-wrapper .active',
        '.cps-button-group-wrapper [data-selected="true"]',
        '.cps-plan-wrapper .selected',
        '.cps-plan-wrapper .active',
        '.cps-plan.selected',
        '.cps-plan.active',
        '.cps-btn.selected',
        '.cps-btn.active',
        '.cps-selected',
        '[data-cps-variant-id].selected',
        '[data-cps-variant-id].active',
        '.cps-warranty-option.selected',
        '.cps-warranty-option.active',
        '.cps-plans-container .selected',
        '.cps-plans-container .active',
        '[class*="cps"][class*="selected"]',
        '[class*="cps"][class*="active"]'
      ];

      for (let i = 0; i < selectors.length; i++) {
        const el = document.querySelector(selectors[i]);
        if (el) {
          const text = (el.textContent || '').toLowerCase();
          if (text.includes('no thanks') || text.includes('no warranty') || text.includes('decline') || el.dataset.action === 'decline' || el.dataset.variantId === '0') {
            return null;
          }
          const variantId = el.dataset.variantId || el.dataset.cpsVariantId || el.dataset.id || el.getAttribute('data-variant-id') || el.getAttribute('data-cps-variant-id') || el.querySelector('[data-variant-id]')?.dataset.variantId || el.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked')?.value;
          if (variantId && /^\d+$/.test(variantId.trim()) && variantId.trim() !== '0') {
            return {
              id: variantId.trim(),
              title: el.dataset.title || el.dataset.planName || el.textContent.trim().split('\n')[0].trim() || 'Extended Warranty',
              properties: {}
            };
          }
        }
      }

      // 3. Checked radio/checkbox inside CPS container
      const checkedRadio = document.querySelector('.cps-button-group-wrapper input[type="radio"]:checked, .cps input[type="radio"]:checked, [class*="cps"] input[type="radio"]:checked');
      if (checkedRadio && checkedRadio.value && /^\d+$/.test(checkedRadio.value.trim()) && checkedRadio.value.trim() !== '0') {
        return {
          id: checkedRadio.value.trim(),
          title: checkedRadio.dataset.title || 'Extended Warranty',
          properties: {}
        };
      }

      // 4. Global CPS object if set on window
      if (window.CPS && window.CPS.selectedPlan && window.CPS.selectedPlan.variant_id) {
        return {
          id: String(window.CPS.selectedPlan.variant_id),
          title: window.CPS.selectedPlan.title || 'Extended Warranty',
          properties: {}
        };
      }

      return null;
    }

    // Unified AJAX Add-to-Cart logic
    function handleCartAdd(form, button, explicitVariantId) {
      if (!button && form) {
        button = form.querySelector('button[type="submit"], [name="add"], .ee-pdp__atc');
      }

      const textEl = button ? (button.querySelector('.ee-pdp__atc-text') || button) : null;
      const originalText = button ? (button.dataset.addText || (textEl ? textEl.textContent : 'Add to Cart')) : 'Add to Cart';

      if (button) {
        button.disabled = true;
        if (textEl) textEl.textContent = 'Adding...';
      }

      const cpsWarranty = getSelectedCpsWarranty(form);

      let fetchPromise;

      if (cpsWarranty) {
        console.log('CPS Extended Warranty detected:', cpsWarranty);
        const mainVariantId = explicitVariantId || (form ? form.querySelector('[name="id"]')?.value : null);
        const mainQty = parseInt((form ? form.querySelector('[name="quantity"]')?.value : null) || '1', 10);
        const productTitle = document.querySelector('.ee-pdp__title')?.textContent?.trim() || document.title;

        const mainProperties = {};
        if (form) {
          form.querySelectorAll('[name^="properties["]').forEach(function(input) {
            const m = input.name.match(/^properties\[(.*)\]$/);
            if (m && input.value) {
              mainProperties[m[1]] = input.value;
            }
          });
        }

        const items = [
          {
            id: parseInt(mainVariantId, 10),
            quantity: mainQty,
            properties: mainProperties
          },
          {
            id: parseInt(cpsWarranty.id, 10),
            quantity: 1,
            properties: Object.assign({
              'Covered Product': productTitle
            }, cpsWarranty.properties || {})
          }
        ];

        fetchPromise = fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        });
      } else if (explicitVariantId) {
        const formData = new FormData();
        formData.append('id', explicitVariantId);
        formData.append('quantity', '1');
        fetchPromise = fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
      } else if (form) {
        fetchPromise = fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
      } else {
        console.error('No variant ID or form provided to add to cart');
        if (button) {
          button.disabled = false;
          if (textEl) textEl.textContent = originalText;
        }
        return;
      }

      fetchPromise
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(data) {
          console.log('Successfully added to cart:', data);
          if (button) {
            button.disabled = false;
            if (textEl) textEl.textContent = 'Added!';
            setTimeout(function() {
              if (textEl) textEl.textContent = originalText;
            }, 2000);
          }

          updateCartDrawer();
          openCartDrawer();
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          if (button) {
            button.disabled = false;
            if (textEl) textEl.textContent = originalText;
          }
          alert((error && error.description) || 'Could not add item to cart. Please try again.');
        });
    }

    // Intercept form submissions for product forms
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!form || !form.tagName || form.tagName.toLowerCase() !== 'form') return;

      const isCartAdd = (form.action && form.action.indexOf('/cart/add') !== -1) ||
                        form.classList.contains('ee-pdp__form') ||
                        form.getAttribute('data-type') === 'add-to-cart-form';

      if (isCartAdd) {
        e.preventDefault();
        const submitter = e.submitter || form.querySelector('button[type="submit"], [name="add"], .ee-pdp__atc');
        handleCartAdd(form, submitter, null);
      }
    });

    // Global function for onclick handlers
    window.addToCart = function(variantId, button) {
      console.log('Add to cart called with variant ID:', variantId);
      const form = button ? (button.closest('form') || document.querySelector('.ee-pdp__form')) : document.querySelector('.ee-pdp__form');
      handleCartAdd(form, button, variantId);
    };

    // Expose drawer functions globally for collection page usage
    window.eeCartDrawer = {
      open: openCartDrawer,
      close: closeCartDrawer,
      update: updateCartDrawer
    };

    // Attach listeners on init
    attachCartItemListeners();

    // Re-render drawer when a warranty is selected inside the drawer
    const drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) {
      drawerEl.addEventListener('click', function(e) {
        const cpsAction = e.target.closest('.warranty_form, .cps-button-group-wrapper p, .cps-button-group-wrapper input, .ee-cart__item-warranty input, .ee-cart__item-warranty button');
        if (cpsAction && !e.target.closest('.learn-more-modal')) {
          setTimeout(updateCartDrawer, 700);
          setTimeout(updateCartDrawer, 1500);
        }
      });

      // Observe DOM mutations inside drawer to keep CPS relocated
      const cpsDrawerObserver = new MutationObserver(function(mutations) {
        for (let i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length > 0) {
            relocateCpsElements();
            break;
          }
        }
      });
      cpsDrawerObserver.observe(drawerEl, { childList: true, subtree: true });
    }

    // Also observe document.body for asynchronously injected CPS elements
    const bodyCpsObserver = new MutationObserver(function(mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const added = mutations[i].addedNodes;
        for (let j = 0; j < added.length; j++) {
          const node = added[j];
          if (node.nodeType === 1 && (node.classList?.contains('cps') || node.querySelector?.('.cps'))) {
            relocateCpsElements();
            return;
          }
        }
      }
    });
    bodyCpsObserver.observe(document.body, { childList: true });

    // Initial relocation
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', relocateCpsElements);
    } else {
      relocateCpsElements();
    }

    console.log('Cart drawer event listeners attached');
  }
})();
